import { Link } from "react-router-dom";

const Misc = () => {
    return (
    <>
    <div className='openFolder'>
        <div className="openNametag">
            <p><Link className='back-button' to="/">Go Back</Link></p>
        </div>
    <div className="document" style={{margin: '-200px 0px 10px 0px'}}>
    <h1 style={{textAlign: 'center'}}>Acknowledgements</h1>
    <p style={{textAlign: 'center'}}><a className="interactive enabled-link-b" href="https://archiveofourown.org/works/20467010/chapters/48563963">Streetlight Pursuit</a> is 
    a Jojo's Bizarre Adventure fanfiction featuring an entirely original cast. It acts as a Part 3.5 and centers around the adventures of five 
    female detectives in 1993 New York as they investigate a missing Stand arrow, the remnants of DIO, and all the other supernatural forces
    at play in Manhattan.</p>
    <p style={{textAlign: 'center'}}>The fic is written by Pianolote and Leafgilly, with additions from Digitalpen and FluffyRoRo.</p>
    <p style={{textAlign: 'center'}} className='enabled-link-a'>This website experience was created, written, and developed by Leafgilly.</p>
    <h2>Development Help</h2>
    <ul>
        <li><span className="enabled-link-r">Pianolote</span> - creative consultant, debugger, and general best coauthor</li>
        <li><span style={{color: '#69359c'}}>Syntaxblitz</span> - helped out so much with getting started in React</li>
        <li><span style={{color: '#89CFF0'}}>dondonhei</span> - post Dota debugging</li>
        <li><span style={{color: '#28282B', backgroundColor: 'white'}}>Big Boopy</span> - debugging and general coding advice</li>
        <li><span style={{color: '#059194'}}>bpolishuk</span> - helping with Github hosting and playtesting</li>
        <li><span style={{color: '#8BCF00'}}>pigserpent</span> - composed Paperback Rigby for Agent Paperback Writer's page of the site</li>
    </ul>
    <h2>Playtesters</h2>
    <ul className='credits'>
        <li><span style={{color: 'red'}}>Pianolote</span></li>
        <li><span style={{color: 'purple'}}>Digitalpen</span></li>
        <li><span style={{color: 'pink'}}>FluffyRoRo</span></li>
        <li><span style={{color: '#059194'}}>bpolishuk</span></li>
        <li><span style={{color: '#28282B', backgroundColor: 'white'}}>Big Boopy</span></li>

    </ul>
    <h2>Readers, Friends, and Supporters</h2>
    <p style={{textAlign: 'center'}}>Whether you've read the whole fic, made art, or just sent a kind word our way, your support genuinely means so much to us. We set out to
        write a fic that made us--the authors--happy. The fact that other people found joy from it too? That makes it all the more worth it. Thank you!
    </p>
    <ul className='credits'>
        <li>Fizzywizard</li>
        <li>Arc</li>
        <li>CG the Bird</li>
        <li>Cream</li>
        <li>Artemisia</li>
        <li>Dip</li>
        <li>Jaded</li>
        <li>Moe</li>
        <li>Myles</li>
        <li>Newbie</li>
        <li>Daed</li>
        <li>Gote</li>
        <li>Poutinerie</li>
        <li>Rabbit</li>
        <li>Sah/Diamond</li>
        <li>Darkdoombob</li>
        <li>Vamp</li>
        <li>Cringe</li>
        <li>Torch</li>
        <li>Weaponx06</li>
        <li>Winter</li>
        <li>Wise</li>
        <li>Egghead</li>
        <li>Maxtot</li>
        <li>Wilbur D Rake</li>
        <li>fauxmantis</li>
        <li>AzraelTheStoryteller</li>
        <li>eldestreyne</li>
        <li>rainyblueshroom</li>
        <li>yuri_aglaya</li>
        <li>Lisa1127</li>
        <li>go_lurk</li>
        <li>mixnmatt1</li>
        <li>chouettechasses</li>
        <li>Mal</li>
        <li>Fetuspie</li>
        <li>Governor_Explosion</li>
        <li>Fizz</li>
        <li>Radon</li>
        <li>Armes</li>
        <li>Maeve</li>
        <li>saintpom</li>
        <li>ripcarl2k17</li>
        <li>kal</li>
        <li>gar</li>
        <li>smonk</li>
        <li>cozmic</li>
        <li>Jellyfly</li>
        <li>Voice0fReason</li>
        <li>koalahobbit</li>
        <li>TheGoodSamaritan</li>
        <li>bonvoyage_noona</li>
        <li>0plus2equals1</li>
        <li>Jin</li>
        <li>Ella</li>
        <li>Shaft</li>
        <li>bxb777</li>
        <li>polysinc</li>
        <li>imaaaaaaaa</li>
        <li>onion</li>
        <li>hypernova</li>
        <li>silvia</li>
        <li>moose lord</li>
        <li>carco11</li>
        <li>GinGerAle</li>
        <li>BuzzLightyearG</li>
        <li>osna</li>
        <li>coop</li>
        <li>verdlo</li>
        <li>zerocrosszero</li>
        <li>omega8</li>
        <li>normalcardboard</li>
        <li>SeleneDistress</li>
        <li>dinoseen</li>
        <li>banquetBeggar</li>
        <li>SomethingYouSaid</li>
        <li>The_Baleful_King</li>
        <li>Android</li>
        <li>Leggoeggo</li>
        <li>HeroOfTime1435</li>
        <li>koleoffline</li>
        <li>medacris</li>
        <li>brennan</li>
        <li>ViziDoodle</li>
        <li>mybedismytruelove</li>
        <li>pokegirl0238</li>
        <li>GhostFloRider</li>
        <li>huffspuffsblows</li>
        <li>hit_that_target</li>
        <li>cOnTaGiOuS_ThOuGhTs</li>
        <li>YeetTheAngels</li>
        <li>Cosmica</li>
        <li>Ryan_Z3R0</li>
        <li>FremderFreundin</li>
        <li>AirKat</li>
        <li>plumedy</li>
        <li>furiousbenson11</li>
        <li>Jigglypuffo</li>
        <li>Melonbottle</li>
        <li>carol</li>
        <li>bonefather</li>
        <li>bondage fairy</li>
        <li>winter_bark</li>
        <li>crowofgayness</li>
        <li>toasteroven</li>
        <li>Glass Paper</li>
        <li>Carol</li>
        <li>Wynaut</li>
        <li>Dia</li>
        <li>Remote_Romance</li>
        <li>Freaklunpa</li>
        <li>a.v.singh</li>
        <li>dragonfuirt</li>
        <li>kizen</li>
        <li>gwalyo</li>
        <li>roro2676</li>
        <li>zero9814ld</li>
        <li>elevampire</li>
        <li>marvelous seki</li>
        <li>y tho</li>
        <li>21stcenturyvelvet</li>
        <li>squibb0</li>
        <li>himeyum11</li>
        <li>gooseman</li>
        <li>ro boat</li>
        <li>tos</li>
        <li>plus</li>
        <li>nitchtuna</li>
        <li>captainblood</li>
        <li>the_original_insomniac</li>
        <li>wyvern</li>
        <li>lenonthedoor</li>
        <li>yukosuz</li>
        <li>someonetooksorrow</li>
        <li>aumiiku</li>
        <li>giorniogiovanna</li>
        <li>vimbo</li>
        <li>cakeh</li>
        <li>gale_sparkleglow</li>
        <li>grandadmiralchee</li>
        <li>Gold</li>
    </ul>
    </div></div></>
    );
    
  };
  
  export default Misc;
  